import React from 'react';
import {
  Link
} from "react-router-dom";
import './App.css';
import data from './content/Home.json';
import { BsBoxArrowUpRight } from 'react-icons/bs';
import { HiArrowRight } from 'react-icons/hi';

var ReactRotatingText = require('react-rotating-text');

function Home() {
  // setHidden(document.documentElement.scrollTop > 1100);
  return (
    <div className="App">
      <div className="landing">
        <div className="landing-content-wrapper">
          <div className="landing-text-wrapper">
            <h2 className="landing-text-title">
              {data.Landing.title}
            </h2>
            <div className="landing-text-tagline">
              <h4><ReactRotatingText items={data.Landing.tags} /></h4>
            </div>
            <div className="landing-text-description">
              {data.Landing.text}
            </div>
            {/* <a href="https://airtable.com/shr9RRSty9KOOGoWD" className="apply-button" rel="noreferrer" style={{color:'#ff0f7b'}} target="_blank"> <BsBoxArrowUpRight/> Apply for our Fall '21 cohort today </a> */}
          </div>
          <div className="landing-graphic-container">
            <img className="landing-graphic" src={data.Landing.image} alt="an image" />
          </div>
        </div>
      </div>
      
      {/* Demo Day teaser
      <div className="content bg-gray">
        <div className="content-wrapper">

          <div className="content-text-wrapper">
            <img src={data.demoday.logo} alt="logo" width="50 rem" style={{verticalAlign:'middle', marginBottom:'1rem'}}/>
            <div className="content-text-tagline">
              <h4>{data.demoday.tagline}</h4>
            </div>
            <div className="content-text-heading">
              <h3>{data.demoday.heading}</h3>
            </div>
            <div className="content-text-description">
              <p>{data.demoday.text}</p>
            </div>
            <Link to={data.demoday.link} className="content-link"> {data.demoday.linktext} <HiArrowRight style={{ verticalAlign: 'middle' }} /> </Link>
          </div>


          <div className="image-placeholder">
            <img src={data.demoday.image} alt="image here" className="content-image"/>
          </div>

        </div>
      </div> */}
      
      {/* Apply Today */}
      {/* <div className="content">
        <div className="content-wrapper">

          <div className="content-text-wrapper">
            <img src={data.demoday.logo} alt="logo" width="50 rem" style={{verticalAlign:'middle', marginBottom:'1rem'}}/>
            <div className="content-text-tagline">
              <h4>{data.apply.tagline}</h4>
            </div>
            <div className="content-text-heading">
              <h3>{data.apply.heading}</h3>
            </div>
            <div className="content-text-description">
              <p>{data.apply.text}</p>
            </div>
            <Link to={data.apply.link} className="content-link"> {data.apply.linktext} <HiArrowRight style={{ verticalAlign: 'middle' }} /> </Link>
          </div>


          <div className="image-placeholder">
            <img src={data.apply.image} alt="image here" className="content-image"/>
          </div>

        </div>
      </div> */}
      
      
      {/* Programming page teaser */}
      <div className="content bg-gray">
        <div className="content-wrapper">

          <div className="content-text-wrapper">
            {/* <img src={data.section1.logo} alt="logo" width="50 rem" style={{verticalAlign:'middle', marginBottom:'1rem'}}/> */}
            <div className="content-text-tagline">
              <h4>{data.section1.tagline}</h4>
            </div>
            <div className="content-text-heading">
              <h3>{data.section1.heading}</h3>
            </div>
            <div className="content-text-description">
              <p>{data.section1.text}</p>
            </div>
            <Link to={data.section1.link} className="content-link"> {data.section1.linktext} <HiArrowRight style={{ verticalAlign: 'middle' }} /> </Link>
          </div>


          <div className="image-placeholder">
            <img src={data.section1.image} alt="image here" className="content-image"/>
          </div>

        </div>
      </div>

      {/* Connections / logo promo teaser */}

      <div className="content">
        <div className="content-tagline">
          <h4>  {data.section2.tagline} </h4>
        </div>
        <div className="content-heading">
          <h3> {data.section2.heading} </h3>
        </div>
        <div className="content-text">
          <p> {data.section2.text} </p>


          <div className="partner-image-container">

            {data.section2.partners.map(partner => (
              <div className="partner">
                <a href={partner.link} className="link-text" rel="noreferrer" target="_blank">
                  <img src={partner.logo} alt="" width={1000 / data.section2.partners.length + "rem"} className="partner-logo" />
                </a>
              </div>
            ))}

          </div>
        </div>
      </div>


    </div>
  );
}

export default Home;
